import {Form} from "react-bootstrap";
import styled from "styled-components";

export const StyleInput = styled(Form.Control).attrs((props) => ({
  name: props.name,
  type: props.type,
  placeholder: props.placeholder
}))`
  min-width: ${(props) => props.minWidth || "100px"};
  width: ${(props) => props.width || "100%"};
  max-width: ${(props) => props.maxWidth || "400px"};
  min-height: ${(props) => props.minHeight || "30px"};
  height: ${(props) => props.height || "40px"};
  max-height: ${(props) => props.maxHeight || "50px"};
  padding: ${(props) => props.padding || "0px"};
  margin: ${(props) => props.margin || "0px"};
  border: ${(props) => props.borderWidth || "1px solid transparent"};
  border-radius: ${(props) => props.borderRadius || "var(--radius-sm)"};
  &:focus {
    outline: none;
    border-color: var(--accent);
  }
`;

export const StyleInputRound = styled(StyleInput)`
  padding: ${(props) => props.paddingLeft || "0px 0px 0px 2rem"};
  border-radius: ${(props) => props.borderRadius || "var(--radius-pill)"};
  &:focus {
    outline: none;
  }
`;

export const StyleInputRoundIcon = styled(StyleInputRound)`
  padding: ${(props) => props.padding || "0px 0px 0px 4rem"};
  outline: ${(props) => props.outLine || "none"};
  cursor: pointer;
  &:focus {
  }
  :focus + .left-icon {
  }
`;

export const StyleInputRoundIconWrapper = styled.div`
  &.inputWithIcon {
    position: relative;
  }
  .left-icon {
    position: absolute;
    left: 1.5rem;
    top: 50%;
    transform: translateY(-50%);
    svg {
      fill: var(--muted);
      transition: 0.3s;
    }
  }
  button.right-icon {
    position: absolute;
    right: 1.5rem;
    top: 50%;
    transform: translateY(-50%);
    background: none;
    border: none;
    svg {
      fill: var(--muted);
      transition: 0.3s;
    }
  }
`;
